import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * BW19 PR-E — Cmd+T (or Ctrl+T) opens /tasks from anywhere in the PWA.
 * Browsers reserve Cmd+T for new-tab; we capture it via keydown but bail
 * if the user is typing into an input. Browser default is preventDefault'd
 * so the OS doesn't open a tab on top of our nav.
 */

export function useTasksShortcut(): void {
  const navigate = useNavigate();
  useEffect(() => {
    function isTextEntry(target: EventTarget | null): boolean {
      if (!(target instanceof HTMLElement)) return false;
      const tag = target.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
      if (target.isContentEditable) return true;
      return false;
    }

    function onKey(e: KeyboardEvent) {
      const meta = e.metaKey || e.ctrlKey;
      if (!meta) return;
      if (e.shiftKey || e.altKey) return;
      if (e.key !== "t" && e.key !== "T") return;
      if (isTextEntry(e.target)) return;
      e.preventDefault();
      navigate("/tasks");
    }

    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [navigate]);
}
